export default "__VITE_ASSET__c6718c7e__"